/**
 * Remove the 'https' from the given url
 * @param {string} url
 */
export const stripUrl = (url: string) =>
  url
    // .replace(/^https?:/, '') // Component Image not working with https
    ?.split('vteximg.com.br')
    ?.join('vtexassets.com')
